/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react"
import number1 from './numbers/number-1.svg'
import number2 from './numbers/number-2.svg'
import number3 from './numbers/number-3.svg'
import number4 from './numbers/number-4.svg'

const MenuContent = ({ navigate }) => {
  return (
    <div className="w-100 h-100 pt-13 pl-13">
      <div onClick={() => navigate("/")} to="/" className='cursor-pointer link font-family-acumin text-blue font-18 line-height-24 font-weight-500'>Introduzione</div>
      <div className='mt-3'>
        <div className='d-flex'>
          <div><img src={number1} alt='Number 1' /></div>
          <div className='text-blue ml-3'>
            <div onClick={() => navigate("/page-2/")} to="/page-2/" className='cursor-pointer link font-18 line-height-24 font-weight-500 font-family-acumin'>La mobilità elettrica</div>
            <div className='font-16 line-height-20'>
              La ricerca di una soluzione sostenibile<br />
              ai tradizionali veicoli a motore a benzina<br />
              trova una via d’uscita nell’elettrico.
            </div>
          </div>
        </div>
      </div>
      <div className='mt-3'>
        <div className='d-flex'>
          <div><img src={number2} alt='Number 2' /></div>
          <div className='text-blue ml-3'>
            <div onClick={() => navigate("/page-6/")} to="/page-6/" className='cursor-pointer link font-18 line-height-24 font-weight-500 font-family-acumin'>
              Le flotte aziendali
            </div>
            <div className='font-16 line-height-20'>
              I veicoli aziendali si stanno spostando <br />
              verso l’elettrico: ecco perché vale <br />
              la pena supportare questa transizione.
            </div>
          </div>
        </div>
      </div>
      <div className='mt-3'>
        <div className='d-flex'>
          <div><img src={number3} alt='Number 3' /></div>
          <div className='text-blue ml-3'>
            <div onClick={() => navigate("/page-10/")} to="/page-10/" className='cursor-pointer link font-18 line-height-24 font-weight-500 font-family-acumin'>
              Edison Fleet Audit
            </div>
            <div className='font-16 line-height-20'>
              L’iniziativa di Edison che favorisce <br />
              la svolta green nelle flotta aziendali, <br />
              puntando sull’alimentazione elettrica. <br />
            </div>
          </div>
        </div>
      </div>
      <div className='mt-3'>
        <div className='d-flex'>
          <div><img src={number4} alt='Number 4' /></div>
          <div className='text-blue ml-3'>
            <div onClick={() => navigate("/page-14/")} to="/page-14/" className='cursor-pointer link font-18 line-height-24 font-weight-500 font-family-acumin'>
              Fleet Audit in prova
            </div>
            <div className='font-16 line-height-20'>
              Come funziona Edison Fleet Audit? <br />
              Dai dati cruciali rilevati alla fattibilità <br />
              della transizione: una panoramica.
            </div>
          </div>
        </div>
      </div>
      <div onClick={() => navigate("/crediti/")} to="/crediti/" className='mt-3 link cursor-pointer link font-family-acumin text-blue font-18 line-height-24 font-weight-500'>Crediti</div>
    </div>
  )
}

export default MenuContent
